export const normalizeLongitude = (lng: number): number => {
  const rotations = Math.floor((Math.abs(lng) + 180) / 360);

  if (lng > 180) {
    return lng - (rotations * 360);
  }

  if (lng < -180) {
    return lng + (rotations * 360);
  }

  return lng;
};
